import React, { useEffect, useState } from "react";
import { Shell, Section } from "@/components/loomi/Layout";
import { ADMIN_NAV } from "./AdminDashboard";
import { api } from "@/lib/api";

export default function AdminRespondents() {
  const [rows, setRows] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/admin/respondents"); setRows(data); })(); }, []);
  return (
    <Shell title="Respondents" portalLabel="Admin" nav={ADMIN_NAV}>
      <Section title="Panel members" testId="section-respondents">
        {rows.length === 0 ? (
          <div className="text-mute text-sm py-8 text-center" data-testid="respondents-empty">No panelists yet.</div>
        ) : (
          <table className="w-full text-sm" data-testid="respondents-table">
            <thead>
              <tr className="text-left text-xs uppercase tracking-widest text-mute border-b border-white/10">
                <th className="py-3 pr-4">Name</th><th className="py-3 pr-4">Email</th><th className="py-3 pr-4">Country</th>
                <th className="py-3 pr-4 text-right">Points</th><th className="py-3 pr-4">Joined</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-b border-white/5 hover:bg-white/5" data-testid={`respondent-row-${r.id}`}>
                  <td className="py-3 pr-4 font-medium">{r.name}</td>
                  <td className="py-3 pr-4 text-mute font-mono text-xs">{r.email}</td>
                  <td className="py-3 pr-4">{r.profile?.country || "—"}</td>
                  <td className="py-3 pr-4 text-right font-mono">{r.points_balance ?? 0}</td>
                  <td className="py-3 pr-4 text-mute text-xs">{new Date(r.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Section>
    </Shell>
  );
}
